import React, { useRef, useEffect, useState } from 'react'

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from 'react-router-dom';
import { carData } from './Data';
import axios from 'axios';
import API_URL from '../ApiUrl/ApiUrl';
const Home = () => {
  const [cars, setCars] = useState([]);

  // const carouselRef = useRef(null);

  // const goToPrevSlide = () => {
  //   if (carouselRef.current) {
  //     carouselRef.current.prev();
  //   }
  // };

  // const goToNextSlide = () => {
  //   if (carouselRef.current) {
  //     carouselRef.current.next();
  //   }
  // };



  const carouselRef = useRef(null);

  const goToPrevSlide = () => {
    if (carouselRef.current) {
      const carousel = carouselRef.current;
      const bsCarousel = new window.bootstrap.Carousel(carousel);
      bsCarousel.prev();
    }
  };

  const goToNextSlide = () => {
    if (carouselRef.current) {
      const carousel = carouselRef.current;
      const bsCarousel = new window.bootstrap.Carousel(carousel);
      bsCarousel.next();
    }
  };

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get(`${API_URL}/cars`);
        const newData= response.data
        const offercar=newData.filter((item)=>item.offer===true)
        // console.log("off",offercar)
        setCars(offercar);
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    };

    fetchCars();
  }, []);
  return (
    <>
      <div className="slider-area pos-relative" style={{
        backgroundImage:
          "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
      }}>
        <div className="slider-active">
          <div className="single-slider slider-height d-flex align-items-center justify-content-center">
            <div className="container">
              <div className="row">
                <div className="col-xl-9 col-md-12 mt-5">
                  <div className="slider-content slider-content-2">
                    <h1
                      className="white-color f-700"
                      data-animation="fadeInUp"
                      data-delay=".2s"
                    >
                      <span>Welcome to Premium</span>
                      <br />
                      Car Rentals.
                    </h1>
                    <p
                      data-animation="fadeInUp"
                      data-delay=".4s"
                      className="fs-3"
                    >
                      Your Ultimate Choice for Corporate Travel in Tanzania!.
                    </p>
                    <Link to="/ourFleet">
                      <button
                        className="theme-btn"
                        data-animation="fadeInUp"
                        data-delay=".6s"
                      >
                        <span className="btn-text">Book Now</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="site-section bg-light sitesection2">
       
        {/* <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <h3>Our Offer</h3>
              <p className="mb-4">Cruise Back in Time with Our Vintage Offers</p>
              <p>
                <button
                  onClick={goToPrevSlide}
                  className="btn btn-primary custom-prev"
                >
                  Previous
                </button>
                <span className="mx-2">/</span>
                <button
                  onClick={goToNextSlide}
                  className="btn btn-primary custom-next"
                >
                  Next
                </button>
              </p>
            </div>
            <div className="col-lg-9">
              <OwlCarousel
                ref={carouselRef}
                className="nonloop-block-13 owl-carousel"
                items={2} 
                loop
                nav={false} 
                autoplay
                autoplayTimeout={3000} 
                autoplayHoverPause 
                margin={30}
              >
                {cars?.map((car, index) => (
                  <div className="col-sm-12 mb-4">
                    <div key={index} className="item-1">
                      <a href="#">
                        <img
                          src={car.images[0]} alt={car.name}
                          className="img-fluid"
                        />
                      </a>
                      <div className="item-1-contents">
                        <div className="text-center">
                          <h3>
                            <a>
                              {car.carName}
                            </a>
                          </h3>
                          <div className="rent-price">
                            <span>TZS {car.carPrice}</span>day
                          </div>
                          <Link to={`/car_booking/${car._id}`} className="btn btn-primary mt-4">
                            Book Now
                          </Link>
                        </div>

                      </div>
                    </div>
                  </div>
                ))}


              </OwlCarousel>
            </div>
          </div>
        </div> */}



<div className="container my-5">
      <div className="row">
        <div className="col-lg-3">
          <h3>Our Offers</h3>
          <p className="mb-4">Cruise Back in Time with Our Vintage Offers</p>
          <p>
            <button
              onClick={goToPrevSlide}
              className="btn btn-primary custom-prev">
              Previous
            </button>
            <span className="mx-2">/</span>
            <button
              onClick={goToNextSlide}
              className="btn btn-primary custom-next">
              Next
            </button>
          </p>
        </div>
        <div className="col-lg-9">
          <div
            id="customCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
            ref={carouselRef}>
            <div className="carousel-inner">
              {cars?.map((car, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}>
                  <div className="d-flex justify-content-center gap-3">
                   
                    <div className="card newcard" style={{ width: "45%" }}>
                    {car?.discount &&   <div className="discount float-end">
                          <div class="discount-text ">
                          <span>{car.discount} Off</span>

                          </div>
                        </div>}
                      <img
                        src={car.images[0]}
                        className="card-img-top"
                        alt={car.name}
                      />
                      <div className="card-body text-center">
                        <h5 className="card-title">{car.carName}</h5>
                        <p className="card-text">
                          TZS {car.carPrice} / Per Day
                        </p>
                        <Link
                          to={`/car_booking/${car._id}`}
                          className="btn btn-primary"
                        >
                          Book Now
                        </Link>
                      </div>
                    </div>
                    {cars[index + 1] && (
                      <>
                      <div className="card newcard2" style={{ width: "45%" }}>
                      {car?.discount &&   <div className="discount float-end">
                          <div class="discount-text ">
                          <span>{car.discount} Off</span>
                          </div>
                        </div>}
                        <img
                          src={cars[index + 1].images[0]}
                          className="card-img-top"
                          alt={cars[index + 1].name}
                        />
                        <div className="card-body text-center">
                          <h5 className="card-title">
                            {cars[index + 1].carName}
                          </h5>
                          <p className="card-text">
                            TZS {cars[index + 1].carPrice} / Per Day
                          </p>
                          <Link
                            to={`/car_booking/${cars[index + 1]._id}`}
                            className="btn btn-primary"
                          >
                            Book Now
                          </Link>
                        </div>
                      </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
      <div
        className="site-section section-3"
        style={{
          backgroundImage:
            'url("https://img.freepik.com/premium-photo/happy-african-american-family-enjoying-car-ride-together_116547-80685.jpg")'
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="text-white">Our services</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="service-1">
                <span className="service-1-icon">
                  <span className="flaticon-car-1" />
                </span>
                <div className="service-1-contents">
                  <h3>Premium Car Rentals</h3>
                  <p>
                    Choose from our fleet of high-end cars to make your travel
                    comfortable and stylish.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-1">
                <span className="service-1-icon">
                  <span className="flaticon-traffic" />
                </span>
                <div className="service-1-contents">
                  <h3>Airport Pickup and Drop-off</h3>
                  <p>
                    Start your journey stress-free with our punctual and reliable
                    airport services..
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-1">
                <span className="service-1-icon">
                  <span className="flaticon-valet" />
                </span>
                <div className="service-1-contents">
                  <h3>Chauffeur Service</h3>
                  <p>
                    Sit back and relax while our professional drivers ensure you
                    have a smooth and pleasant ride.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container site-section mb-5">
        <div className="row justify-content-center text-center">
          <div className="col-7 text-center mb-5">
            <h2>How it works</h2>
            <p>
              Our user-friendly platform ensures a quick and easy reservation
              process.
            </p>
          </div>
        </div>
        <div className="how-it-works d-flex">
          <div className="step">
            <span className="number">
              <span>01</span>
            </span>
            <span className="caption">Time &amp; Place</span>
          </div>
          <div className="step">
            <span className="number">
              <span>02</span>
            </span>
            <span className="caption">Car</span>
          </div>
          <div className="step">
            <span className="number">
              <span>03</span>
            </span>
            <span className="caption">Details</span>
          </div>
          <div className="step">
            <span className="number">
              <span>04</span>
            </span>
            <span className="caption">Checkout</span>
          </div>
          <div className="step">
            <span className="number">
              <span>05</span>
            </span>
            <span className="caption">Done</span>
          </div>
        </div>
      </div>
      <div className="site-section bg-light">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-7 text-center mb-5">
              <h2>Customer Testimony</h2>
              <p>
                At Premium Car Rentals, I found more than just a car; I discovered
                an experience that made my trip unforgettable.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="testimonial-2">
                <blockquote className="mb-4">
                  <p>
                    "Renting from Premium Car Rentals was seamless! The car was in
                    pristine condition.
                  </p>
                </blockquote>
                <div className="d-flex v-card align-items-center">
                  <img
                    src="https://www.shutterstock.com/image-photo/african-person-speaking-camera-giving-260nw-1835255230.jpg"
                    alt="Image"
                    className="img-fluid mr-3"
                  />
                  <span> Mashaka S.</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="testimonial-2">
                <blockquote className="mb-4">
                  <p>
                    Absolutely loved the service and selection. It made my weekend
                    trip unforgettable.
                  </p>
                </blockquote>
                <div className="d-flex v-card align-items-center">
                  <img
                    src="https://www.shutterstock.com/image-photo/portrait-african-american-woman-smiling-260nw-1629683485.jpg"
                    alt="Image"
                    className="img-fluid mr-3"
                  />
                  <span> Marwa M.</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="testimonial-2">
                <blockquote className="mb-4">
                  <p>
                    The rental process was quick and efficient, and the luxury car I
                    chose was well worth it.
                  </p>
                </blockquote>
                <div className="d-flex v-card align-items-center">
                  <img
                    src="https://cbx-prod.b-cdn.net/COLOURBOX64197480.jpg?width=800&height=800&quality=70"
                    alt="Image"
                    className="img-fluid mr-3"
                  />
                  <span> Hussein H.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Home
